import * as React from "react";
import * as ReactDOM from "react-dom";
import { autoprefixer } from "diy/material-ui/autoprefixer";
import SyncPosition, {PositionBox} from "diy/components/SyncPosition";
import l10n = require('diy/util/l10n');
import Modul from "../../Modul";

function getModulesThatDoNotFit(): Modul[] {
    // get all modules ids that do not fit
    return Modul.getAllInstances().filter((module: Modul) => !module.getFitsInContent());
}

export function updateAll() {
    let modulesIdsDoesNotFit = getModulesThatDoNotFit();
    if (!modulesIdsDoesNotFit.length) { // do nothing if all modules fit
        return;
    }

    // add the container for the masks, if it does not exist
    let modulesTooLargeContainer = document.getElementById('diy-modules-too-large');
    if (!modulesTooLargeContainer) {
        modulesTooLargeContainer = document.createElement('div');
        modulesTooLargeContainer.setAttribute('id', 'diy-modules-too-large');
        document.body.appendChild(modulesTooLargeContainer);
    }

    // get module ids that do not fit and build syncpositions around them
    let modulesTooLargeOverlaysList = modulesIdsDoesNotFit.map((module: Modul) => {
        let modulEl = module.getModuleElement()[0] as HTMLElement;

        return <SyncPosition
            element={modulEl}
            position="absolute"
            key={"module-too-large-overlay-" + module.moduleId}
        >
            {
                // if the element we're monitoring becomes invisible, don't re-render any more
                // TODO improve state handling with Redux in the future
                (box: PositionBox) => (box.width > 0 && box.height > 0) ? <div style={
                    autoprefixer({
                        background: 'rgba(245, 218, 218, 0.7)',
                        border: '1px solid #DC7376',
                        boxSizing: 'border-box',
                        padding: 18,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        top: box.top,
                        left: box.left,
                        width: box.width,
                        height: box.height,
                        position: 'absolute',
                        pointerEvents: 'none'
                    })}>
                        <p style={{textAlign: 'center', marginBottom: 18}}>
                            {l10n.getString('module.doesNotFit.title')}
                        </p>
                        <p style={{textAlign: 'center'}}>
                            {l10n.getString('module.doesNotFit.description')}
                        </p>
                    </div> : null
                }
        </SyncPosition>;
    });

    ReactDOM.render(
        <div className="diye">{modulesTooLargeOverlaysList}</div>,
        modulesTooLargeContainer
    );
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/ModuleFitsInContent.tsx
 **/